import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareAlignRightIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 15 17' {...props}>
    <path
      d='M14 1v3h-3V1h3zm1-1h-5v5h5V0zM4 7v3H1V7h3zm1-1H0v5h5V6zM7 13v3H4v-3h3zm1-1H3v5h5v-5zM15 7h-1v1h1V7zm0 3h-1v1h1v-1zm0 3h-1v1h1v-1zm0 3h-1v1h1v-1zM11 7v1H6v1h5v1l2-1.5L11 7zM11 13v1H9v1h2v1l2-1.5-2-1.5z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M14 1v3h-3V1h3zm1-1h-5v5h5V0zM14 7v3h-3V7h3zm1-1h-5v5h5V6zM14 13v3h-3v-3h3zm1-1h-5v5h5v-5z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const AlignRightIcon = memo(BareAlignRightIcon);
